﻿@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.screens_driver

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.example.project.engineslot.SLOT_BEREICH_WA
import org.example.project.engineslot.slotDisplayDate
import org.example.project.utils.All
import org.example.project.utils.LocalizationManager
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun DriverMeineAuftraegePreviewCard(
    card: DriverBookingCardModel,
    expanded: Boolean,
    documentCount: Int? = null,
    onToggle: () -> Unit
) {
    val t: (String) -> String = { LocalizationManager.get(it) }
    val date = card.booking.datum.ifBlank { card.booking.verladedatum }
    val time = card.booking.uhrzeitVon.ifBlank { card.booking.verladeuhrzeit }.ifBlank { card.booking.uhrzeitAnmeldung }
    val artLabel = if (card.artCode == SLOT_BEREICH_WA) t("laden") else t("liefern")

    Div({
        classes(if (expanded) DriverOrderStyles.previewTileActive else DriverOrderStyles.previewTile)
        onClick { onToggle() }
    }) {
        Div({ classes(DriverOrderStyles.previewTopRow) }) {
            Span({ classes(DriverOrderStyles.previewArt) }) { Text(artLabel) }
        Span({ classes(DriverOrderStyles.previewDate) }) {
            Text("${slotDisplayDate(date)} | ${time.ifBlank { "-" }} ${t("driver_time_suffix")}")
        }
    }
    Span({ classes(DriverOrderStyles.previewRef) }) {
        Text("${t("driver_delivery_note_number")}: ${card.booking.lieferscheinnummer.ifBlank { card.primaryRef }.ifBlank { "-" }}")
    }
    Span({ classes(DriverOrderStyles.previewCompany) }) {
        Text(card.firmaLabel.ifBlank { card.currentTargetLabel }.ifBlank { "-" })
    }
        Span({ classes(DriverOrderStyles.previewAddress) }) {
            Text(card.adresseLabel.ifBlank { "-" })
        }
        if (card.isDriverFinalAuftrag()) {
            Span({
                style {
                    alignSelf(AlignSelf.FlexEnd)
                    color(rgba(255, 255, 255, 0.78))
                    fontSize(12.px)
                    fontWeight("800")
                    lineHeight("1.25")
                    textAlign("right")
                }
            }) {
                Text(t("driver_documents_existing").replace("{count}", (documentCount ?: 0).toString()))
            }
        }
    }
}

@Composable
fun DriverMeineAuftraegeCard(
    card: DriverBookingCardModel,
    clickable: Boolean = true,
    onOpen: () -> Unit
) {
    val t: (String) -> String = { LocalizationManager.get(it) }
    val sammelAuftraege = card.sammelAuftraege.takeIf { card.isSammelabholung() }.orEmpty()
    val ladestellen = card.standortRows.takeIf { card.artCode == SLOT_BEREICH_WA && !card.isSammelabholung() && it.size > 1 }.orEmpty()
    var sammelPage by remember(card.booking.id, sammelAuftraege.size) { mutableStateOf(0) }
    if (sammelPage > sammelAuftraege.lastIndex) sammelPage = 0
    val visibleAuftrag = sammelAuftraege.getOrNull(sammelPage) ?: card.booking
    val date = card.booking.datum.ifBlank { card.booking.verladedatum }
    val time = card.booking.uhrzeitVon.ifBlank { card.booking.verladeuhrzeit }.ifBlank { card.booking.uhrzeitAnmeldung }

    Div({
        classes(DriverOrderStyles.tile)
        if (clickable) {
            style { cursor("pointer") }
            onClick { onOpen() }
        } else {
            style { cursor("default") }
        }
    }) {
        DriverMeineAuftraegeCardHeader(
            artCode = card.artCode,
            belegCount = sammelAuftraege.size.takeIf { it > 1 } ?: 1,
            dateLabel = "${slotDisplayDate(date)} | ${time.ifBlank { "-" }} ${t("driver_time_suffix")}",
            endToEndFlow = card.booking.endToEndFlow
        )
        DriverMeineAuftraegeInfoRow(
            t("driver_delivery_note_number"),
            visibleAuftrag.lieferscheinnummer.ifBlank { card.primaryRef }.ifBlank { "-" }
        )
        DriverMeineAuftraegeInfoRow(t("lieferant"), visibleAuftrag.lieferant.ifBlank { card.booking.lieferant }.ifBlank { "-" })
        DriverMeineAuftraegeInfoRow(t("driver_recipient"), visibleAuftrag.empfaenger.ifBlank { card.booking.empfaenger }.ifBlank { "-" })
        DriverMeineAuftraegeInfoRow(t("auftraggeber"), visibleAuftrag.auftraggeber.ifBlank { card.booking.auftraggeber }.ifBlank { "-" })
        DriverMeineAuftraegeInfoRow(t("driver_state"), card.zustandLabel.ifBlank { "-" })
        DriverMeineAuftraegeInfoRow(t("driver_assigned_by"), card.gebuchtVonLabel)
        DriverMeineAuftraegeInfoRow(t("driver_company"), card.firmaLabel.ifBlank { "-" })
        if (ladestellen.isNotEmpty()) {
            ladestellen.forEachIndexed { index, ladestelle ->
                DriverMeineAuftraegeInfoRow("${t("standort_adresse")} ${index + 1}", ladestelle.driverAdresseLabel().ifBlank { "-" })
            }
        } else {
            DriverMeineAuftraegeInfoRow(t("standort_adresse"), card.adresseLabel.ifBlank { "-" })
        }
        DriverMeineAuftraegeInfoRow(t("unternehmer"), visibleAuftrag.unternehmer.ifBlank { card.booking.unternehmer }.ifBlank { "-" })
        DriverMeineAuftraegeInfoRow(t("driver_driver"), visibleAuftrag.fahrername.ifBlank { card.booking.fahrername }.ifBlank { "-" })
        DriverMeineAuftraegeInfoRow(t("driver_truck"), visibleAuftrag.lkwkennzeichen.ifBlank { card.lkwLabel }.ifBlank { "-" })
        DriverMeineAuftraegeInfoRow(t("driver_trailer"), visibleAuftrag.aufliegerkennzeichen.ifBlank { card.aufliegerLabel }.ifBlank { "-" })
        if (!card.palettentauschAktiv) {
            Div({
                style {
                    marginTop(4.px)
                    padding(10.px, 12.px)
                    borderRadius(8.px)
                    backgroundColor(rgba(150, 18, 18, 0.72))
                    border(1.px, LineStyle.Solid, rgba(255, 90, 90, 0.58))
                    color(Color("#ffd7d7"))
                    fontSize(13.px)
                    fontWeight("800")
                    lineHeight("1.35")
                }
            }) {
                Text(t("driver_no_pallet_exchange_warning"))
            }
        }
        if (card.isSammelabholung()) {
            DriverMeineAuftraegeCardPager(
                current = sammelPage,
                total = sammelAuftraege.size,
                onPrevious = {
                    sammelPage = if (sammelPage <= 0) sammelAuftraege.lastIndex else sammelPage - 1
                },
                onSelect = { index -> sammelPage = index },
                onNext = {
                    sammelPage = if (sammelPage >= sammelAuftraege.lastIndex) 0 else sammelPage + 1
                }
            )
        }
    }
}

@Composable
private fun DriverMeineAuftraegeCardHeader(
    artCode: String,
    belegCount: Int,
    dateLabel: String,
    endToEndFlow: Boolean = false
) {
    Div({ classes(DriverOrderStyles.tileTopRow) }) {
        DriverMeineAuftraegeHeaderItem(
            icon = if (artCode == SLOT_BEREICH_WA) "images/wa.svg" else "images/we.svg",
            text = if (artCode == SLOT_BEREICH_WA) LocalizationManager.get("driver_pick_up") else LocalizationManager.get("liefern")
        )
        if (endToEndFlow) {
            DriverMeineAuftraegeHeaderItem(
                icon = "images/end_to_end_flow.svg",
                text = "End-to-End"
            )
        }
        DriverMeineAuftraegeHeaderItem(
            icon = "images/beleg.svg",
            text = belegCount.toString()
        )
        DriverMeineAuftraegeHeaderItem(
            icon = "images/kalender.svg",
            text = dateLabel
        )
    }
}

@Composable
private fun DriverMeineAuftraegeHeaderItem(icon: String, text: String) {
    Span({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(6.px)
            minWidth(0.px)
            color(rgba(255, 255, 255, 0.82))
            fontSize(12.px)
            fontWeight("700")
        }
    }) {
        Img(src = icon) {
            style {
                width(18.px)
                height(18.px)
                flexShrink(0)
                property("filter", "brightness(0) invert(1)")
            }
        }
        Span({
            style {
                minWidth(0.px)
                overflow("hidden")
                property("text-overflow", "ellipsis")
                whiteSpace("nowrap")
            }
        }) {
            Text(text)
        }
    }
}

@Composable
private fun DriverMeineAuftraegeCardPager(
    current: Int,
    total: Int,
    onPrevious: () -> Unit,
    onSelect: (Int) -> Unit,
    onNext: () -> Unit
) {
    Div({
        style {
            marginTop(4.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            gap(12.px)
            color(Color.white)
            property("user-select", "none")
        }
        onClick { event -> event.stopPropagation() }
    }) {
        DriverMeineAuftraegePagerIcon("images/left.svg", onPrevious)
        (0 until total).forEach { index ->
            Span({
                style {
                    fontSize(14.px)
                    fontWeight("800")
                    cursor("pointer")
                    if (index == current) {
                        property("text-decoration", "underline")
                        property("text-underline-offset", "4px")
                    }
                }
                onClick { event ->
                    event.stopPropagation()
                    onSelect(index)
                }
            }) {
                Text((index + 1).toString())
            }
        }
        DriverMeineAuftraegePagerIcon("images/right.svg", onNext)
    }
}

@Composable
private fun DriverMeineAuftraegePagerIcon(icon: String, onClick: () -> Unit) {
    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            width(24.px)
            height(24.px)
            flexShrink(0)
            cursor("pointer")
            property("user-select", "none")
        }
        onClick { event ->
            event.stopPropagation()
            onClick()
        }
    }) {
        Img(src = icon) {
            style {
                width(18.px)
                height(18.px)
                property("filter", "brightness(0) invert(1)")
            }
        }
    }
}

@Composable
private fun DriverMeineAuftraegeInfoRow(label: String, value: String) {
    if (value.isBlank()) return
    Div({ classes(DriverOrderStyles.infoRow) }) {
        Span({ classes(DriverOrderStyles.infoLabel) }) { Text(label) }
        Span({ classes(DriverOrderStyles.infoValue) }) { Text(value) }
    }
}

private fun All.driverAdresseLabel(): String =
    listOf(strasse, hausnummer, plz, ort)
        .filter { it.isNotBlank() }
        .joinToString(" ")
